/** @jsx jsx */
import { Theme } from '@emotion/react';
import styled from '@emotion/styled';
import tokens from '@vaad1st/shared.design-tokens/json/variables.json';

import { BreakPointToken } from '@vaad1st/hook.media-query';

type BackgroundProps = {
	hasSummary?: boolean;
	float?: boolean;
	theme: Theme;
};

type ButtonProps = {
	visible: boolean;
};

// This seems daft but you have to pass the theme in to use theme _and_ props. Sure there's another way around this though...
export const Background = styled.div<BackgroundProps>`
	${(props: BackgroundProps) => ({
		backdropFilter: props?.float ? `blur(10px)` : 'none',
		backgroundColor: props?.hasSummary
			? 'var(--color-background-neutral-secondary)'
			: 'var(--color-background-brand-red)',
		padding: `${tokens.spacing_16px.value}px 0`,
		position: 'absolute',
		top: 0,
		insetInlineStart: 0,
		insetInlineEnd: 0,

		[`@media screen and (min-width: ${BreakPointToken.SmMin}px)`]: {
			padding: `${tokens.spacing_20px.value}px 0`
		}
	})}
`;

export const SummaryTrigger = styled.button<ButtonProps>`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	background: ${tokens.color_light_background_neutral_primary};
	border: none;
	cursor: pointer;
	padding: ${tokens.spacing_12px.value}px;
	border-radius: ${tokens.spacing_40px.value}px;
	opacity: 1;
	color: ${tokens.color_light_text_neutral_primary};

	@media (min-width: ${BreakPointToken.SmMin}px) {
		padding: ${tokens.spacing_16px.value}px;
		border: 1px solid ${tokens.color_light_border_neutral_subtle};
		opacity: ${({ visible }) => (visible ? 1 : 0)};
		transition: opacity 0.3s ease-in-out;
	}
`;

export const SearchIcon = styled.div`
	width: ${tokens.spacing_48px.value}px;
	height: ${tokens.spacing_48px.value}px;
	border-radius: ${tokens.spacing_48px.value}px;
	background: ${tokens.color_light_background_brand_red};
	color: ${tokens.color_light_background_neutral_primary};
	flex-shrink: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	line-height: 1;

	@media (min-width: ${BreakPointToken.SmMin}px) {
		width: ${tokens.spacing_48px.value}px;
		height: ${tokens.spacing_48px.value}px;
	}
`;

export const SearchLabel = styled.div`
	display: block;
	flex-shrink: 0;
	margin-block: 0;
	margin-inline-end: 0;
	margin-inline-start: ${tokens.spacing_24px.value}px;
	pointer-events: none;
	background: var(--color-background-brand-red);
	color: var(--color-text-neutral-primary-inverse);
	padding: 12px 16px;
	border-radius: ${tokens.spacing_24px.value}px;
	display: flex;
	align-items: center;
	justify-content: center;

	svg {
		margin-inline-end: ${tokens.spacing_8px.value}px;
	}
`;
